module.exports = __webpack_public_path__ + "static/media/da.fb5a88ee.png";